import "./css/Footer.css";

import { Link } from "react-router-dom";
import React from "react";

// import { BiMessageDetail } from "react-icons/bi";


const Footer = ({addressStreet, addressNumber, addressPostcode, addressCity}) => {
  

  return (
    <div className="chooseFooter">
      <div className="desktopFooter">
        <div className="desktopFooterFlex">
          <div className="FooterCol">
            <div className="FooterRow">
              <div className="footerLogo">
                <Link to="/">
                  <div className="imgholder">
                    <img
                      src="img/logo/logo.svg"
                      className="footerLogoIMG"
                      alt="footerLogo"
                    ></img>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="FooterCol">
            <div className="FooterAddress">
              <h3>Ludwigsfelder Radballclub e.V.</h3>
              <p>{addressStreet} {addressNumber}</p>
              <p>{addressPostcode} {addressCity}</p>
            </div>
          </div>
          <div className="FooterCol">
            <div className="imgholder FooterSocials">
              <a
                href="https://www.instagram.com/ludwigsfelderrc/"
                target="_blank" rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                  alt="Instagram"
                  style={{ width: "50px", height: "50px" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mobileFooter">
        <div className="desktopFooterFlex">
          <div className="FooterCol">
            <div className="FooterRow">
              <div className="footerLogo">
                <Link to="/">
                  <div className="imgholder">
                    <img
                      src="img/logo/logo.svg"
                      className="footerLogoIMG"
                      alt="footerLogo"
                    ></img>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="FooterCol">
            <div className="FooterAddress">
              <h3>Ludwigsfelder Radballclub e.V.</h3>
              <p>{addressStreet} {addressNumber}</p>
              <p>{addressPostcode} {addressCity}</p>
            </div>
          </div>
          <div className="FooterCol">
            <div className="imgholder FooterSocials">
              <a
                href="https://www.instagram.com/ludwigsfelderrc/"
                target="_blank" rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                  alt="Instagram"
                  style={{ width: "50px", height: "50px" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
